import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useResponsiveContext } from '../../../functions/responsive/ResponsiveContext';
import { FontFamily } from '../../styles/Colors';

export const useButtonStylePresets = () => {
  const { rpx } = useResponsiveContext();
  return useMemo(
    () =>
      StyleSheet.create({
        normalStyle: {
          minWidth: rpx(80),
          minHeight: rpx(44),
          borderRadius: rpx(25),
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: rpx(15),
          paddingRight: rpx(15),
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        },
        normalTextStyle: FontFamily.boldFlattened({
          fontSize: rpx(14),
          lineHeight: rpx(22),
          letterSpacing: rpx(-0.34),
        }),
      }),
    [rpx],
  );
};
